import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  downloadXML: id =>
    api
      .send({
        query: gql`
          query downloadXML($id: ID!) {
            Bitacora {
              downloadXML(id: $id)
            }
          }
        `,
        variables: {
          id
        }
      })
      .then(result => result.data.data.Bitacora.downloadXML),

  readByIdFactura: idFactura =>
    api
      .send({
        query: gql`
          query readByIdFactura($idFactura: ID!) {
            Bitacora {
              readByIdFactura(idFactura: $idFactura) {
                doc {
                  createdAt
                  estadoDocumento {
                    id
                    value
                    annotation
                  }
                  mensaje
                }
              }
            }
          }
        `,
        variables: {
          idFactura
        }
      })
      .then(result => result.data.data.Bitacora.readByIdFactura)
}
